import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import { push } from 'react-router-redux';
import { setLoader, removeLoader } from '../../../../actions';
import { AdvertiserApi } from '../../../../api';
import { CampaignIndexTable } from '../../../../components/advertisers/campaigns';
import { ButtonAdd } from '../../../../components/common/buttons';


class Index extends Component {
  componentDidMount() {
    this.fetchResource();
  }

  fetchResource(params = {}) {
    const { account, dispatch } = this.props;
    const startMonth = moment().startOf('month');
    const endMonth = moment().endOf('month');

    if (account.uuid) {
      const data = { ...params, account_id: account.uuid };

      dispatch(AdvertiserApi.actions.campaigns.get(data, (_error, success) => {
        if (success) {
          const reportData = {
            ...params,
            referencenumbers: success.data.map((value) => {
              return value.referencenumber;
            }),
            account_id: account.uuid,
            since: startMonth.toISOString(),
            until: endMonth.toISOString()
          };
          dispatch(AdvertiserApi.actions.campaignReports.get(reportData));
        }
      }));
    }
  }

  handleStatus(r, action) {
    const { dispatch, account, campaigns } = this.props;
    const args = [account.uuid, r.uuid, {
      status: action === 'pause' ? 'paused' : 'active'
    }];

    dispatch(setLoader('CampaignStatusUpdate'));
    dispatch(AdvertiserApi.actions.campaignUpdate.patch(...args, (_error, success) => {
      dispatch(removeLoader('CampaignStatusUpdate'));
      if (success) {
        const collection = [...campaigns.data].map((obj) => {
          return obj.uuid === success.data.uuid ? success.data : obj;
        });

        dispatch({
          type: AdvertiserApi.events.campaigns.actionSuccess,
          syncing: false,
          data: { ...campaigns, data: collection, meta: { ...campaigns.meta } }
        });
      }
    }));
  }

  handleClick(e) {
    e.preventDefault();
  }

  redirectToNew() {
    const { dispatch, account } = this.props;
    dispatch(push(`/advertiser/home/accounts/${account.slug}/campaigns/new`));
  }

  render() {
    const { account, isLoading } = this.props;

    return (
      <div className='ibox'>
        <div className='ibox-title border-bottom'>
          <h5>Campaigns</h5>
        </div>
        <div
          className={`p-b-lg ibox-content${isLoading ? ' sk-loading' : ''}`}
        >
          <CampaignIndexTable account={account}>
            <ButtonAdd
              btnLabel='Create Campaign'
              onClick={this.redirectToNew.bind(this)}
              className='pull-left'
            />
          </CampaignIndexTable>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    loader,
    advertiser: {
      campaigns: {
        data: campaigns, loading: isLoading
      },
      campaignReports: {
        data: campaignReports, loading: reportIsLoading
      },
      accounts
    }
  } = state;
  const { params: { accountSlug } } = ownProps;
  const account = (accounts.data.data || [])
    .filter((w) => w.slug === accountSlug)[0] || {};


  return {
    campaigns,
    campaignReports,
    reportIsLoading,
    isLoading,
    account,
    statusLoading: loader.includes('CampaignStatusUpdate')
  };
};

export default connect(mapStateToProps)(Index);
